import { DbAssetObjectInfos } from "../../Core/Api/Types/db-asset-object-infos";
import { DbOrderItemInfos } from "../../Core/Api/Types/db-order-item-infos";

// Number
export const handleSelectClickNumber = (
  selectedItems: number[],
  setSelectedNumbers: React.Dispatch<React.SetStateAction<number[]>>
) => {
  return (index: number) => {
    if (!selectedItems) return;

    const isAlreadySelected = selectedItems.findIndex((item) => item === index) !== -1;

    if (!setSelectedNumbers) return;

    if (!isAlreadySelected) setSelectedNumbers((prevState) => [...prevState, index]);
    else setSelectedNumbers((prevState) => prevState.filter((item) => item !== index));
  };
};

export const isItemSelectedNumber = (index: number, selectedItems: number[]) => {
  if (!selectedItems) return false;

  return selectedItems.findIndex((item) => item === index) !== -1;
};

// Objects
export const handleSelectClickObject = (
  selectedItems: DbAssetObjectInfos[],
  setSelectedObjects: React.Dispatch<React.SetStateAction<DbAssetObjectInfos[]>>
) => {
  return (obj: DbAssetObjectInfos) => {
    if (!selectedItems) return;

    const isAlreadySelected = selectedItems.findIndex((item) => item.id === obj.id) !== -1;

    if (!setSelectedObjects) return;

    if (!isAlreadySelected) setSelectedObjects((prevState) => [...prevState, obj]);
    else setSelectedObjects((prevState) => prevState.filter((item) => item.id !== obj.id));
  };
};

// Objects
export const handleSelectClickOrderItem = (
  selectedItems: DbOrderItemInfos[],
  setSelectedObjects: React.Dispatch<React.SetStateAction<DbOrderItemInfos[]>>
) => {
  return (obj: DbOrderItemInfos) => {
    if (!selectedItems) return;

    const isAlreadySelected = selectedItems.findIndex((item) => item.id === obj.id) !== -1;

    if (!setSelectedObjects) return;

    if (!isAlreadySelected) setSelectedObjects((prevState) => [...prevState, obj]);
    else setSelectedObjects((prevState) => prevState.filter((item) => item.id !== obj.id));
  };
};

export const isItemSelectedObject = (obj: DbAssetObjectInfos, selectedItems: DbAssetObjectInfos[]) => {
  if (!selectedItems) return false;

  return selectedItems.findIndex((item) => item.id === obj.id) !== -1;
};
